{
  "clinic_ivf_estimate": {
    "national_ivf_estimate": "Vos chances avec la FIV",
    "national_model_scope": "Estimations nationales du CDC, fondées sur des personnes aux caractéristiques similaires.",
    "explore_your_ivf_chances": "Explorez vos chances avec la FIV",
    "national_estimates_explained": "Explorez les estimations nationales selon votre âge et vos antécédents reproductifs. Les résultats publiés par la clinique figurent séparément ci-dessous.",
    "enter_your_details": "Renseigner mes informations",
    "chance_of_live_birth": "Probabilité cumulée de naissance vivante",
    "after_one_retrieval": "Après 1 ponction ovocytaire",
    "after_multiple_retrievals": "Après ${count} ponctions ovocytaires",
    "after_one_additional_retrieval": "Après 1 ponction ovocytaire supplémentaire",
    "after_multiple_additional_retrievals": "Après ${count} ponctions ovocytaires supplémentaires",
    "after_one_donor_transfer": "Après 1 transfert d’embryon issu d’un don d’ovocytes",
    "after_multiple_donor_transfers": "Après ${count} transferts d’embryons issus d’un don d’ovocytes",
    "own_egg_time_horizon": "Chaque ponction comprend tous les transferts d’embryons frais et congelés dans les 12 mois. Chaque pourcentage inclut les chances des ponctions précédentes.",
    "donor_time_horizon": "Ces estimations couvrent les 1 à 3 premiers transferts d’embryons issus d’un don d’ovocytes, dans les 12 mois suivant le premier transfert. Chaque pourcentage inclut les chances des transferts précédents.",
    "bmi_used": "IMC utilisé dans le modèle : ${bmi}. Le CDC borne cette valeur entre 17 et 45.",
    "national_data_context": "Ces estimations utilisent les données de traitements américains de 2016 à 2018. Elles concernent des personnes aux caractéristiques similaires et ne prédisent pas les performances de cette clinique.",
    "details_used_for_estimate": "Informations utilisées pour cette estimation",
    "age_used": "Âge : ${age} ans",
    "bmi_used_value": "IMC utilisé : ${bmi}",
    "first_ivf_course": "Première FIV",
    "previous_ivf_course": "FIV antérieure",
    "first_donor_transfer_course": "Premier transfert avec don d’ovocytes",
    "pregnancies_used": "Grossesses précédentes : ${count}",
    "births_used": "Naissances vivantes précédentes : ${count}",
    "edit_estimate_detail": "Modifier ${detail}",
    "estimate_without_diagnosis_details": "Cette estimation utilise le modèle du CDC sans détails diagnostiques.",
    "review_your_details": "Indiquez l’âge, les mesures et les antécédents de la personne ayant recours à la FIV. En cas de don d’ovocytes, utilisez les informations de la receveuse. Répondez à chaque question et sélectionnez toutes les causes diagnostiquées ou « Je ne sais pas / aucune raison ».",
    "age_in_years": "Âge en années",
    "height_cm": "Taille",
    "weight_kg": "Poids",
    "previous_ivf_use": "Avez-vous déjà eu recours à la FIV ?",
    "used_ivf_before": "Oui",
    "first_ivf_treatment": "Non, c’est ma première fois",
    "egg_source": "Quels ovocytes utiliserez-vous ?",
    "donor_eggs": "Ovocytes de donneuse",
    "own_eggs": "Mes propres ovocytes",
    "first_donor_course": "Le modèle pour le don d’ovocytes couvre les 1 à 3 premiers transferts d’embryons.",
    "previous_pregnancies": "Grossesses précédentes",
    "previous_live_births": "Naissances vivantes précédentes",
    "two_or_more": "2 ou plus",
    "reason_for_ivf": "Raison du recours à la FIV",
    "diagnosis": {
      "male_factor": "Facteur masculin",
      "endometriosis": "Endométriose",
      "tubal": "Facteur tubaire",
      "pco": "Trouble ovulatoire / SOPK",
      "diminished_ovarian_reserve": "Réserve ovarienne diminuée",
      "uterine": "Facteur utérin",
      "other": "Autre raison",
      "unexplained": "Infertilité inexpliquée"
    },
    "diagnosis_not_known": "Je ne sais pas / aucune raison",
    "supported_inputs": "Le modèle couvre les âges de 20 à 50 ans, les tailles de 122 à 241 cm et les poids de 36,3 à 136 kg. Après une FIV avec ses propres ovocytes, l’âge doit être compris entre 24 et 48 ans.",
    "births_cannot_exceed_pregnancies": "Le nombre de naissances vivantes précédentes ne peut dépasser le nombre de grossesses précédentes.",
    "returning_age_range": "Ce modèle couvre les personnes ayant déjà eu recours à la FIV, âgées de 24 à 48 ans.",
    "calculate_your_estimate": "Calculer mon estimation",
    "about_cdc_model": "À propos du modèle du CDC",
    "open_cdc_ivf_estimator": "Ouvrir l’estimateur du CDC",
    "opens_cdc_website_in_browser": "Ouvre le site du CDC dans votre navigateur.",
    "discuss_with_your_clinic": "Parlez avec votre clinique de ce que ces estimations signifient pour votre parcours. Elles sont informatives et ne garantissent aucun résultat.",
    "previous_donor_transfers": "Avez-vous déjà eu un transfert d’embryon issu d’un don d’ovocytes ?",
    "had_donor_transfer_before": "Oui, j’en ai déjà eu un",
    "first_donor_transfer": "Non, ce sera mon premier",
    "returning_donor_not_supported": "Ce modèle couvre un premier recours au don d’ovocytes. Demandez à votre clinique vos chances après un transfert antérieur issu d’un don d’ovocytes.",
    "health_notes": "Notes",
    "add_health_note": "Ajouter une note…",
    "sign_in_to_save_health_note": "Connectez-vous pour enregistrer votre note.",
    "save_health_note": "Enregistrer la note",
    "health_note_saved": "Enregistrée",
    "health_note_save_failed": "Impossible d’enregistrer votre note. Réessayez."
  }
}
